export const userConstants = {
  CHANGE_FOOTER_STATUS: "CHANGE_FOOTER_STATUS",
  REMEMBER: "REMEMBER",
  REMOVE_REMEMBER: "REMOVE_REMEMBER",
  LOADING_SHOW: "LOADING_SHOW",
  LOADING_HIDE: "LOADING_HIDE",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGOUT: "USERS_LOGOUT",
  ME: "ME",
  INDICATORS: "INDICATORS",
  ANY: "ANY",
  TEMP: "TEMP",
  WARDS: "WARDS",
  USERS: "USERS",
  HOSPITALS: "HOSPITALS",
  COMMITTEES: "COMMITTEES",
  ALL_ANSWERER_INFO_MENU_ITEMS: "ALL_ANSWERER_INFO_MENU_ITEMS",
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  SERVER_URL_2: process.env.REACT_APP_SERVER_URL_2,
  SNJAB_URL: process.env.REACT_APP_SNJAB_URL,
  REACT_URL: process.env.REACT_APP_REACT_URL,
  COLORS: [
    "#f00",
    "#ffbb18",
    "#0063d1",
    "#2f9693",
    "#ea8b47",
    "#c62bfc",
    "#b45a33",
    "#f70264",
    "#5e7cdd",
    "#02ccf7",
    "#92c020",
    "#c93253",
    "#ffb67b",
    "#9a59b5",
    "#8d4a28",
    "#d8659b",
  ],

  ERRORS: {
    username: "لطفا نام کاربری خود را وارد کنید.",
    password: "کلمه عبور را وارد کنید.",
    onlyFarsi: "کیبورد فارسی باشد.",
    loginAdmin:
      "شما در صفحه ادمین هستید. دسترسی غیر مجاز فقط مدیر اجازه ورود دارد.",
    serverError: "موقتاً سرور با مشکل مواجه است. لطفاً کمی بعد مجدد تلاش کنید.",
    noEop:
      "برای شاخص مورد نظر تاکنون مقداری وارد نشده است. اقدام اصلاحی بر روی مقادیر اندازه گیری شده امکان پذیر است.",
    logoutIn5: "هشدار امنیتی از زمان نشست مجاز شما 5 دقیقه باقی مانده است.",
    logoutIn1:
      "کاربر گرامی در صورت خروج خودکار (یک دقیقه دیگر) مجدد وارد شوید.",
  },

  months: [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ],
  seasons: ["بهار", "تابستان", "پاییز", "زمستان"],
  sixMonths: ["شش ماهه اول سال", "شش ماهه دوم سال"],
  year: ["سالیانه"],
};
export const ROTATION = {
  روزانه: "",
  هفتگی: "w",
  ماهانه: "m",
  "سه ماه یکبار": "3m",
  "شش ماه یکبار": "6m",
  سالانه: "y",
};
